<template>
    <el-form :model="giftBagSetting"
             v-form
             editAction="dbtCard/saveRecruitSettingInfo.action"
             addAction= "dbtCard/saveRecruitSettingInfo.action"
             selectAction="dbtCard/selectRecruitSettingInfo.action"
             @onEdited="onSaved"
             @onAdded="onSaved"
             :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">

        <el-form-item>
            <template slot="label">
                <h3 style="margin-bottom: -10px;">经纪人</h3>
            </template>
        </el-form-item>
        <el-form-item label="权益介绍" prop="agentRightsDesc">
            <el-input v-model="giftBagSetting.agentRightsDesc" type="textarea" :rows="6" placeholder="请输入权益介绍"></el-input>
        </el-form-item>

        <el-form-item label="收益介绍" prop="agentIncomeDesc">
            <el-input v-model="giftBagSetting.agentIncomeDesc" type="textarea" :rows="6" placeholder="请输入收益介绍"></el-input>
        </el-form-item>

        <hr/>

       <!-- <el-form-item>
            <template slot="label">
                <h3>合伙人</h3>
            </template>
        </el-form-item>

        <el-form-item label="权益介绍" prop="dealerRightsDesc">
            <el-input v-model="giftBagSetting.dealerRightsDesc" type="textarea" :rows="6" placeholder="请输入权益介绍"></el-input>
        </el-form-item>

        <el-form-item label="收益介绍" prop="dealerIncomeDesc">
            <el-input v-model="giftBagSetting.dealerIncomeDesc" type="textarea" :rows="8" placeholder="请输入收益介绍"></el-input>
        </el-form-item>

        <el-form-item label="升级指标" prop="checkedDealerUpgradeIndicators">

            <el-input style="width:210px" type="number" :disabled="disabled" v-model="giftBagSetting.dealerAgentCount">
                <template slot="prepend">招募经纪人</template>
            </el-input>
            <el-input style="width:210px;margin-left:10px;" type="number" :disabled="disabled" v-model="giftBagSetting.dealerMemberCount">
                <template slot="prepend">且推广会员</template>
            </el-input>

        </el-form-item>

        <hr/>-->
<!--        <el-form-item>-->
<!--            <template slot="label">-->
<!--                <h3>区域服务商</h3>-->
<!--            </template>-->
<!--        </el-form-item>-->

<!--        <el-form-item label="权益介绍" prop="serviceRightsDesc">-->
<!--            <el-input v-model="giftBagSetting.serviceRightsDesc" type="textarea" :rows="6" placeholder="请输入，例如：-->
<!--1、含经纪人相关的权益-->
<!--2、获得合伙人购卡优惠权益，3元/次"></el-input>-->
<!--        </el-form-item>-->

<!--        <el-form-item label="收益介绍" prop="serviceIncomeDesc">-->
<!--            <el-input v-model="giftBagSetting.serviceIncomeDesc" type="textarea" :rows="8" placeholder="请输入，例如：-->
<!--1、零售权益卡收益：获得每次约26.9元的会员推广收益。-->
<!--2、直拓经纪人收益：获得一次性209元的经纪人招募收益。-->
<!--3、间拓经纪人收益：旗下经纪人拓展经纪人获得60元礼包收益-->
<!--注意：与旗下合伙人处于同等级角色时，旗下合伙人的推广业绩与上级无关。"></el-input>-->
<!--        </el-form-item>-->

<!--        <el-form-item label="升级指标" prop="checkedServiceUpgradeIndicators">-->
<!--            <el-input style="width:210px" type="number" v-model="giftBagSetting.serviceAgentCount">-->
<!--                <template slot="prepend">招募经纪人</template>-->
<!--            </el-input>-->
<!--            <el-input style="width:210px;margin-left:10px;" type="number" v-model="giftBagSetting.serviceMemberCount">-->
<!--                <template slot="prepend">且推广会员</template>-->
<!--            </el-input>-->
<!--        </el-form-item>-->

        <el-form-item>
            <el-button type="primary" >立即保存</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'distributor-setting',
  components: { TableTemplate },
  data () {
    return {
      disabled: false,
      // 经纪人升级指标
      agentUpgradeIndicators: ['开通权益卡', '完成个人实名', '完成公司认证', '购买会员礼包', '完成推广目标'],

      // 合伙人升级指标
      dealerUpgradeIndicators: ['完成公司认证', '完成推广目标'],

      // 区域服务商升级指标
      serviceUpgradeIndicators: ['完成推广目标'],

      options: [{
        value: 365,
        label: '充值后365天内有效'
      }],
      giftBagSetting: {
        id: 1,
        name: null,
        cardDesc: null,
        retailPrice: null,
        agentPurchasePrice: null,
        agentBuyMixNum: null,
        dealerPurchasePrice: null,
        dealerBuyMixNum: null,
        effectiveDays: 365,

        dealerAgentCount: null,
        dealerMemberCount: null,
        agentAgentCount: null,
        agentMemberCount: null,
        serviceAgentCount: null,
        serviceMemberCount: null,
        memberAgreementName: null,
        memberAgreementUrl: null,
        agentAgreementName: null,
        agentAgreementUrl: null,
        checkedServiceUpgradeIndicators: [],
        checkedDealerUpgradeIndicators: [],
        checkedAgentUpgradeIndicators: []
      },
      rules: {
        agentRightsDesc: [
          { required: true, message: '请输入经纪人权益介绍', trigger: 'blur' }
        ],
        agentIncomeDesc: [
          { required: true, message: '请输入经纪人收益介绍', trigger: 'blur' }
        ],
        dealerRightsDesc: [
          { required: true, message: '请输入合伙人权益介绍', trigger: 'blur' }
        ],
        dealerIncomeDesc: [
          { required: true, message: '请输入合伙人收益介绍', trigger: 'blur' }
        ],
        serviceRightsDesc: [
          { required: true, message: '请输入服务商权益介绍', trigger: 'blur' }
        ],
        serviceIncomeDesc: [
          { required: true, message: '请输入服务商收益介绍', trigger: 'blur' }
        ],
        memberAgreementName: [
          { required: true, message: '请输入会员协议名', trigger: 'blur' }
        ],
        memberAgreementUrl: [
          { required: true, message: '请输入会员协议链接', trigger: 'blur' }
        ],
        agentAgreementName: [
          { required: true, message: '请输入经纪人协议名', trigger: 'blur' }
        ],
        agentAgreementUrl: [
          { required: true, message: '请输入经纪人协议链接', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onSaved () {
      this.$message({ type: 'success', message: '保存成功！' })
      return true
    },
    onSelectInfo (dataInfo) {
      // if (dataInfo.datas) {
      //   this.disabled = true
      // } else {
      //   this.disabled = false
      // }
    }
  }
}
</script>
